export default "__VITE_ASSET__BBB349vd__"